<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="110px">
            <el-form-item label="用户名/昵称:" prop="nickname"> <el-input type="text" v-model="form.nickname" />
            </el-form-item>
            <el-form-item label="手机:" prop="phoneNumber"> <el-input type="text" v-model="form.phoneNumber"
                    maxlength="11" show-word-limit /> </el-form-item>
            <el-form-item label="真实姓名:" prop="identityCardName">
                <div style="display:flex">
                    <el-input type="text" v-model="form.identityCardName" style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="身份证号:" prop="identityCardNo">
                <div style="display:flex">
                    <el-input type="text" v-model="form.identityCardNo" maxlength="18" show-word-limit
                        style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="入住彩种:" prop="lotteryTypes">
                <el-select v-model="form.lotteryTypes" placeholder="请选择" :multiple='true'>
                    <el-option v-for="item in select.arr" :key="item.roleId" :label="item.roleName"
                        :value="item.roleId">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="原创性技巧声明" prop="originalityStatement">
                <el-input v-model="form.originalityStatement" type="textarea" :rows="3"
                    placeholder="请填写您的原创性技巧声明" />
            </el-form-item>

            <el-form-item prop="identityCardFront" label="身份证正面">
                <div class="id-card-uploader" @click="fileType = 'front'">
                    <el-upload accept="image/jpeg,image/png" action='' :auto-upload="false" :show-file-list="false"
                        :onChange="chooseFile">
                        <div v-if="showImg.front" class="upload-preview">
                            <el-image :src='showImg.front' fit="cover"></el-image>
                            <div class="upload-mask">点击重新上传</div>
                        </div>
                        <div v-else-if="uploading.front" class="upload-progress-box">
                            <el-progress type="circle" :percentage="uploadPercent.front" :width="90"></el-progress>
                        </div>
                        <div v-else class="upload-placeholder">
                            <i class="el-icon-picture-outline"></i>
                            <div class="upload-text">点击上传身份证正面</div>
                        </div>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item prop="identityCardBack" label="身份证反面">
                <div class="id-card-uploader" @click="fileType = 'bank'">
                    <el-upload accept="image/jpeg,image/png" action='' :auto-upload="false" :show-file-list="false"
                        :onChange="chooseFile">
                        <div v-if="showImg.bank" class="upload-preview">
                            <el-image :src='showImg.bank' fit="cover"></el-image>
                            <div class="upload-mask">点击重新上传</div>
                        </div>
                        <div v-else-if="uploading.bank" class="upload-progress-box">
                            <el-progress type="circle" :percentage="uploadPercent.bank" :width="90"></el-progress>
                        </div>
                        <div v-else class="upload-placeholder">
                            <i class="el-icon-picture-outline"></i>
                            <div class="upload-text">点击上传身份证反面</div>
                        </div>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item prop="avatar" label="头像上传">
                <div class="id-card-uploader avatar-box" @click="fileType = 'avatar'">
                    <el-upload accept="image/jpeg,image/png" action='' :auto-upload="false" :show-file-list="false"
                        :onChange="chooseFile">
                        <div v-if="showImg.avatar" class="upload-preview">
                            <el-image :src='showImg.avatar' fit="cover"></el-image>
                            <div class="upload-mask">点击重新上传</div>
                        </div>
                        <div v-else-if="uploading.avatar" class="upload-progress-box">
                            <el-progress type="circle" :percentage="uploadPercent.avatar" :width="90"></el-progress>
                        </div>
                        <div v-else class="upload-placeholder">
                            <i class="el-icon-picture-outline"></i>
                            <div class="upload-text">点击上传头像</div>
                        </div>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item label="是否有60人以上的彩票QQ、微信群" label-width="250px" prop="groupChat">
                <el-input v-model="form.groupChat" type="text" placeholder="如果没有填无，如果有说明投注站信息" />
            </el-form-item>
            <el-form-item label="是否有投注站" prop="bettingShopManager">
                <el-input v-model="form.bettingShopManager" type="text" placeholder="如果没有填无，如果有说明投注站信息" />
            </el-form-item>
            <el-form-item label="实操excel年限" prop="shrinkTime">
                <el-radio-group v-model="form.shrinkTime">
                    <el-radio label="1">两年以内</el-radio>
                    <el-radio label="2">2-5年</el-radio>
                    <el-radio label="3">5-10年</el-radio>
                    <el-radio label="4">10年以上</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="是否自己做VBA的excel表">
                <el-input v-model="form.bettingShopManager" type="text" placeholder="如果没有填无，如果有说明投注站信息"/>
            </el-form-item> -->
            <el-form-item label="qq号" prop="qqNumber">
                <el-input type="text" v-model="form.qqNumber" />
            </el-form-item>
            <el-form-item label="微信号" prop="wechatNumber">
                <el-input type="text" v-model="form.wechatNumber" />
            </el-form-item>
            <el-form-item label="生日" prop="birthday">
                <el-date-picker v-model="form.birthday" type="date" value-format='yyyy-MM-dd' placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="性别" style="paddingBottom:0">
                <el-radio-group v-model="form.gender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                    <el-radio label="2">保密</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="网站对原创性技巧师的寄语">
                <el-input type="text" v-model="form."/>
            </el-form-item> -->
            <el-form-item label="软件交易师最喜欢的彩票座右铭" prop="motto" label-width="220px">
                <div style="display:flex">
                    <el-input type="text" placeholder="用一句话概括" v-model="form.motto" />
                    <el-button type="primary" style="margin-left: 20px;"
                        @click="$refs.popupMotto.init()">选择座右铭</el-button>
                </div>
            </el-form-item>

            <el-form-item label="是否每年都有原创思路定制成软件" style="paddingBottom:0" label-width="230px">
                <el-radio-group v-model="form.customSoftware">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否不定期根据自己的需要添置好用软件" style="paddingBottom:0" label-width="270px">
                <el-radio-group v-model="form.addSoftware">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="submit" :loading="saveBtnLoading">确定</el-button>
            </el-form-item>
        </el-form>


        <motto ref="popupMotto" @confirm="e => this.form.motto = e"></motto>
    </div>
</template>

<script>
import motto from '@/components/motto/index.vue'
import {
    software_role_list,
    software_register
} from '@/api/apply'
import { queryUuIdInfo } from '@/api/common'
export default {
    components: { motto },
    data() {
        return {
            checkList: ['两年以内'],
            select: {
                arr: [],
                val: "",
            },
            imageUrl: '',

            fileType: '',

            form: {
                id: '',
                nickname: '',
                phoneNumber: '',
                identityCardName: '',
                identityCardNo: '',
                lotteryTypes: [],     //彩种（用户自行选择）
                originalityStatement: '',   //原创性技巧声明
                identityCardBack: '',
                identityCardFront: '',
                avatar: '',
                bettingShopManager: '',
                groupChat: '',
                motto: '',
                qqNumber: '',
                wechatNumber: '',
                birthday: '',
                gender: '',
                shrinkTime: '',
                type: 's_software', 	//对应岗位类型：s_shrinkage：缩水师 ，s_technician：技巧师，s_software：软件师


                // isTzz:'',           //是否是投注站
                addSoftware: 0,        //是否添置好用软件：0否 1是
                customSoftware: 1,     //是否定制成软件：0否 1是
                // sss_msg:'',         //缩水师认识
            },

            rules: {
                nickname: { required: true, message: '请输入用户名/昵称', trigger: 'change' },
                phoneNumber: {
                    required: true,
                    message: '请输入有效的中国大陆手机号码',
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        const phonePattern = /^1[3456789]\d{9}$/;
                        if (!phonePattern.test(value)) {
                            callback(new Error('请输入有效的中国大陆手机号码'));
                        } else {
                            callback();
                        }
                    }
                },
                identityCardName: { required: true, message: '请输入真实姓名', trigger: 'change' },
                identityCardNo: {
                    required: true,
                    message: '请输入身份证号',
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        // 基本的身份证号码格式验证
                        const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;

                        if (!idCardPattern.test(value)) {
                            callback(new Error('请输入正确的身份证号'));
                        } else {
                            // 验证身份证号最后一位校验码
                            if (value.length === 18) {
                                const numArr = value.split('');
                                const factorArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                                const checkCodeArr = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
                                let sum = 0;

                                for (let i = 0; i < 17; i++) {
                                    sum += parseInt(numArr[i]) * factorArr[i];
                                }

                                const remainder = sum % 11;
                                if (numArr[17].toUpperCase() !== checkCodeArr[remainder]) {
                                    callback(new Error('请输入正确的身份证号'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        }
                    }
                },
                lotteryTypes: { required: true, message: '请选择彩种', trigger: ['change', 'blur'] },

                identityCardFront: { required: true, message: '请上传正面', trigger: 'change' },
                identityCardBack: { required: true, message: '请上传反面', trigger: 'change' },
                avatar: { required: true, message: '请上传头像', trigger: 'change' },

                groupChat: { required: true, message: '是否有60人以上的qq群或者微信群', trigger: 'change' },
                bettingShopManager: { required: true, message: '是否是投注站', trigger: 'change' },

                qqNumber: { required: true, message: 'qq号', trigger: 'change' },
                wechatNumber: { required: true, message: '微信号', trigger: 'change' },
                birthday: { required: true, message: '生日', trigger: 'change' },
                motto: { required: true, message: '座右铭', trigger: 'change' },

            },


            showImg: {
                front: '',
                bank: '',
                avatar: '',
            },
            loading: false,
            uploading: { front: false, bank: false, avatar: false },   // 各上传框独立的上传中状态
            uploadPercent: { front: 0, bank: 0, avatar: 0 },           // 各上传框独立进度

            saveBtnLoading: false,
        };
    },
    mounted() {
        // 获取软件师对应的角色列表
        software_role_list().then(res => {
            this.select.arr = res.data
        })

        queryUuIdInfo().then(res => this.form.id = res)
    },
    methods: {
        chooseFile(e) {
            // 锁定当前槽位，避免上传过程中切换 fileType 导致进度/结果串台
            const slot = this.fileType

            let fileType_number = slot == 'front' ? 'id_card_front' :
                slot == 'bank' ? 'id_card_back' :
                    slot == 'avatar' ? 'avatar' : ''

            const data = (() => { const fd = new FormData(); fd.append('file', e.raw); return fd; })();
            let params = `?fileType=${fileType_number}&bizId=${this.form.id}&number=${fileType_number}`

            this.loading = true
            this.uploading[slot] = true
            this.uploadPercent[slot] = 0


            // console.log(this.$utils.upLoadFile);
            this.$utils.upLoadFile(params, data, (ev) => {
                if (ev.lengthComputable) {
                    this.uploadPercent[slot] = Math.floor(ev.loaded / ev.total * 100)
                }
            }).then(res => {

                if (slot == 'front') {
                    this.form.identityCardFront = res.data.urls
                    this.$refs.form.validateField('identityCardFront')
                }
                if (slot == 'bank') {
                    this.form.identityCardBack = res.data.urls
                    this.$refs.form.validateField('identityCardBack')
                }
                if (slot == 'avatar') {
                    this.form.avatar = res.data.urls
                    this.$refs.form.validateField('avatar')
                }

                this.showImg[slot] = this.$utils.fileToBolb(e.raw)

                this.uploading[slot] = false
                this.loading = false
            }).catch(err => {
                console.log('err', err);
                this.$message.error((err && err.msg) ? err.msg : '上传失败，请确认已登录后重试')
                this.uploading[slot] = false
                this.loading = false
            })

        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.saveBtnLoading = true
                    software_register(this.form).then(res => {
                        console.log('res', res);
                        this.loading = false
                        this.saveBtnLoading = false
                        if (res.code == 200) {
                            this.$message.success('申请成功，请耐性等待1-5个工作日')
                            this.resetForm()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.$message.warning('请完善标红的必填项后再提交')
                    return false;
                }
            });
        },
        resetForm() {
            this.showImg = {
                front: '',
                bank: '',
                avatar: '',
            }

            // for(let i in this.form){
            // 	this.form[i] = ''
            // }
            queryUuIdInfo().then(res => this.form.id = res)
            this.$refs.form.resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>
.id-card-uploader {
    .el-upload {
        display: block;
    }

    .upload-placeholder,
    .upload-preview {
        width: 260px;
        height: 160px;
        border: 1px dashed #c0c4cc;
        border-radius: 10px;
        background: #fafbfc;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        transition: all .2s ease;
    }

    .upload-placeholder:hover {
        border-color: #409eff;
        background: #f0f7ff;

        .upload-text,
        i {
            color: #409eff;
        }
    }

    .upload-placeholder i {
        font-size: 40px;
        color: #c0c4cc;
        margin-bottom: 10px;
        transition: color .2s ease;
    }

    .upload-text {
        font-size: 14px;
        color: #909399;
        transition: color .2s ease;
    }

    .upload-preview .el-image {
        width: 100%;
        height: 100%;
    }

    .upload-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        color: #fff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity .2s ease;
    }

    .upload-preview:hover .upload-mask {
        opacity: 1;
    }

    .upload-progress-box {
        width: 260px;
        height: 160px;
        border: 1px solid #ebeef5;
        border-radius: 10px;
        background: #fafbfc;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.avatar-box {

        .upload-placeholder,
        .upload-preview,
        .upload-progress-box {
            width: 160px;
            height: 160px;
        }
    }
}

.el-form-item {
    margin-bottom: 11px;
    padding-bottom: 11px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.msg {
    color: #f56c6c;
    font-size: 15px;
}
</style>